import { render, staticRenderFns } from "./Mycc.vue?vue&type=template&id=a0c99868&scoped=true&"
import script from "./Mycc.vue?vue&type=script&lang=js&"
export * from "./Mycc.vue?vue&type=script&lang=js&"
import style0 from "./Mycc.vue?vue&type=style&index=0&id=a0c99868&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a0c99868",
  null
  
)

export default component.exports